/* eslint-disable object-curly-newline */
import React from 'react';
import { modal, colors, radii, space } from 'style/config';
import { Box, Image, Text } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';

function CheckboxImageFilter({ isSelected, label, value, image, onClick, isRedesigned, hideIcon }) {
    return (
        <Box
            is='div'
            display='flex'
            alignItems='center'
            data-at={Sephora.debug.dataAt('color_option')}
            onClick={() => onClick(value)}
            lineHeight='tight'
            paddingY='2px'
            baseCss={{
                outline: 0,
                transition: 'background-color .2s',
                '.no-touch &:hover, :focus': { backgroundColor: colors.nearWhite }
            }}
            {...(isRedesigned
                ? {
                    css: styles.filter(isSelected, hideIcon)
                }
                : {
                    paddingX: [modal.paddingX[0] - 2, 3]
                })}
        >
            {!hideIcon && (
                <Box
                    borderRadius='full'
                    border={2}
                    borderColor={isSelected && !isRedesigned ? 'black' : 'transparent'}
                    flexShrink={0}
                    marginRight={isRedesigned ? 2 : '.5em'}
                    padding={isRedesigned ? 0 : '2px'}
                >
                    <Image
                        borderRadius='full'
                        display='block'
                        src={image}
                        size={isRedesigned ? 36 : 32}
                    />
                </Box>
            )}
            <Text overflowWrap='break-word'>{label}</Text>
        </Box>
    );
}

const styles = {
    filter: (isSelected, hideIcon) => ({
        width: 164,
        height: 52,
        paddingLeft: hideIcon ? 0 : space[2],
        justifyContent: hideIcon ? 'center' : 'flex-start',
        paddingRight: 2,
        borderStyle: 'solid',
        borderColor: isSelected ? colors.black : colors.midGray,
        borderWidth: isSelected ? 2 : 1,
        borderRadius: radii[3]
    })
};

export default wrapFunctionalComponent(CheckboxImageFilter, 'CheckboxImageFilter');
